/*
 * @Autor: lianxiben
 * @Date: 2023-02-20 11:49:06
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-02-20 20:01:35
 */
import axios from '@/utils/axiosHelper';

// 初始化
export const init = (params) => {
  return axios({ url: `/lantern/activity/book/init`, method: 'GET', params }, { interceptResultCode: false });
};
// 预约
export const book = (params) => {
  return axios({ url: `/lantern/activity/book/store`, method: 'POST', params }, { interceptResultCode: false });
};
// 领取礼包
export const packages = (params) => {
  return axios({ url: `/lantern/activity/book/package`, method: 'POST', params }, { interceptResultCode: false });
};
// 注销
export const destroy = (params) => {
  return axios({ url: `/lantern/activity/book/destroy`, method: 'POST', params }, { interceptResultCode: false });
};
// 微信配置
export const settingShare = (params) => {
  return axios({ url: `/wechat/jssdk`, method: 'POST', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/tideng/anniversaryCelebration/api.js